/**
 * Recursively removes empty fields, null values, empty arrays, and empty objects from an object
 * @param {Object} obj - The object to clean
 * @returns {Object} - The cleaned object
 */
export const cleanEmptyFields = obj => {
  if (!obj || typeof obj !== 'object') return obj

  // Handle arrays
  if (Array.isArray(obj)) {
    const filteredArr = obj
      .map(item => cleanEmptyFields(item))
      .filter(item => {
        if (item === null || item === undefined) return false
        if (typeof item === 'object' && Object.keys(item).length === 0) return false
        if (Array.isArray(item) && item.length === 0) return false
        return true
      })
    return filteredArr.length ? filteredArr : undefined
  }

  // Handle objects
  const result = {}
  for (const key in obj) {
    const value = cleanEmptyFields(obj[key])

    // Skip null, undefined, empty strings, empty arrays, and empty objects
    if (value === null || value === undefined) continue
    if (value === '') continue
    if (Array.isArray(value) && value.length === 0) continue
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) continue

    result[key] = value
  }

  return Object.keys(result).length ? result : undefined
}

export const convertEmptyStringsToNull = (obj, seen = new WeakMap()) => {
  if (!obj || typeof obj !== 'object') return obj
  if (seen.has(obj)) return seen.get(obj)

  const convertedObject = Array.isArray(obj) ? [] : {}
  seen.set(obj, convertedObject)

  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (typeof value === 'object') {
      acc[key] = convertEmptyStringsToNull(value, seen)
    } else {
      acc[key] = value === '' ? null : value
    }
    return acc
  }, convertedObject)
}
